/* eslint-disable max-len */
/**
 * @file 消息中心路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

export default [
  {
    label: '消息中心',
    href: '/agency/notice',
    key: 'notice',
    component: loadable(() => import(/* webpackChunkName: 'notice' */ /* webpackMode: 'lazy' */ '@/pages/agency/notice/Layout'), { fallback: <Loading /> }),
    hide: true,
  },
];
